import React, { Component } from 'react';

import { AlertError } from '../AlertError';
import { AlertInfo }  from '../AlertInfo';

type AlertProps = {
    status: string,
    message: string,
}

function Alert({message}: AlertProps) {
    if (!message || message.length == 0) {
        return (<div></div>);
    }

    if (status == "error") {
        return <AlertError message={message} />
    } 

    return <AlertInfo message={message} />
}

export { 
    Alert
}